import React, { useState, useEffect } from 'react';
import './App.css';
import FakturafordelingWizard from './FakturafordelingWizard';

const API_URL = 'https://advokat-api.swagner.workers.dev';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [cases, setCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(null);
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('cases'); // 'cases' eller 'admin'
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [showNewCase, setShowNewCase] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState('');
  const [showFakturafordeling, setShowFakturafordeling] = useState(false);
  const [newCase, setNewCase] = useState({
    caseNumber: '',
    caseType: 'avhendingsloven',
    clientName: '',
    description: ''
  });

  useEffect(() => {
    if (token) {
      loadCases();
    }
    // eslint-disable-next-line
  }, [token]);

  const register = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name })
      });
      const data = await response.json();
      if (data.success) {
        alert('✅ Bruker opprettet! Du kan nå logge inn.');
        setIsRegistering(false);
        setName('');
      } else {
        alert('Registrering feilet: ' + (data.error || 'Ukjent feil'));
      }
    } catch (error) {
      alert('Registrering feilet: ' + error.message);
    }
    setLoading(false);
  };

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      if (data.token) {
        setToken(data.token);
        localStorage.setItem('token', data.token);
      } else {
        alert('Login feilet: ' + (data.error || 'Ukjent feil'));
      }
    } catch (error) {
      alert('Login feilet: ' + error.message);
    }
    setLoading(false);
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('token');
    setCases([]);
    setSelectedCase(null);
  };

  const loadCases = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/cases`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setCases(data.cases || []);
    } catch (error) {
      console.error('Feil ved lasting av saker:', error);
    }
    setLoading(false);
  };

  const createCase = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/cases`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newCase)
      });
      const data = await response.json();
      if (data.id) {
        setShowNewCase(false);
        setNewCase({ caseNumber: '', caseType: 'avhendingsloven', clientName: '', description: '' });
        loadCases();
      } else {
        alert('Feil ved opprettelse: ' + (data.error || 'Ukjent feil'));
      }
    } catch (error) {
      alert('Feil ved opprettelse: ' + error.message);
    }
    setLoading(false);
  };

  const analyzeCase = async (caseId) => {
    setLoading(true);
    setAnalysis(null);
    try {
      const response = await fetch(`${API_URL}/cases/${caseId}/analyze`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ analysisType: 'full' })
      });
      const data = await response.json();
      setAnalysis(data);
    } catch (error) {
      alert('Feil ved analyse: ' + error.message);
    }
    setLoading(false);
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    setLoading(true);
    setUploadProgress('Laster opp filer...');

    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    try {
      const response = await fetch(`${API_URL}/admin/upload-dommer`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setUploadProgress(`✅ Lastet opp ${data.uploaded} dommer`);
        setUploadedFiles([...uploadedFiles, ...data.files]);
      } else {
        setUploadProgress(`❌ Feil: ${data.error}`);
      }
    } catch (error) {
      setUploadProgress(`❌ Feil ved opplasting: ${error.message}`);
    }

    setLoading(false);
  };

  if (!token) {
    return (
      <div className="App">
        <div className="login-container">
          <h1>🔐 Advokatsystem</h1>
          <p className="subtitle">GDPR-compliant juridisk AI</p>

          {isRegistering ? (
            <form onSubmit={register} className="login-form">
              <input type="text" placeholder="Navn" value={name} onChange={(e) => setName(e.target.value)} required />
              <input type="email" placeholder="E-post" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <input type="password" placeholder="Passord (min 8 tegn)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength="8" />
              <button type="submit" disabled={loading}>{loading ? 'Registrerer...' : 'Registrer'}</button>
              <button type="button" onClick={() => setIsRegistering(false)} className="switch-btn">
                Har allerede konto? Logg inn
              </button>
            </form>
          ) : (
            <form onSubmit={login} className="login-form">
              <input type="email" placeholder="E-post" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <input type="password" placeholder="Passord" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <button type="submit" disabled={loading}>{loading ? 'Logger inn...' : 'Logg inn'}</button>
              <button type="button" onClick={() => setIsRegistering(true)} className="switch-btn">
                Ny bruker? Registrer deg
              </button>
            </form>
          )}

          <div className="system-status">
            <p>API: {API_URL}</p>
            <p>Kryptert • GDPR-compliant • Norsk lov</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="header">
        <h1>Advokatsystem</h1>
        <div className="nav-tabs">
          <button className="fakturafordeling-main-btn" onClick={() => setShowFakturafordeling(true)}>
            📄 Fakturafordeling
          </button>
          <button className={view === 'cases' ? 'active' : ''} onClick={() => setView('cases')}>
            📁 Saker
          </button>
          <button className={view === 'admin' ? 'active' : ''} onClick={() => setView('admin')}>
            📚 Kunnskapsbase
          </button>
        </div>
        <button onClick={logout} className="logout-btn">Logg ut</button>
      </header>

      {showFakturafordeling && (
        <FakturafordelingWizard
          token={token}
          onClose={() => setShowFakturafordeling(false)}
          onComplete={() => {
            loadCases();
            alert('✅ Fakturafordeling fullført!');
          }}
        />
      )}
      <div className="main-container">

      {view === 'cases' ? (
        <>
        <div className="sidebar">
          <div className="sidebar-header">
            <h2>Saker ({cases.length})</h2>
            <button onClick={() => setShowNewCase(!showNewCase)} className="new-case-btn">+ Ny sak</button>
          </div>
          {showNewCase && (
            <form onSubmit={createCase} className="new-case-form">
              <input type="text" placeholder="Saksnummer (2026-001)" value={newCase.caseNumber} onChange={(e) => setNewCase({...newCase, caseNumber: e.target.value})} required />
              <select value={newCase.caseType} onChange={(e) => setNewCase({...newCase, caseType: e.target.value})}>
                <option value="avhendingsloven">Avhendingsloven</option>
                <option value="bustadoppforingslova">Bustadoppføringslova</option>
              </select>
              <input type="text" placeholder="Klientnavn" value={newCase.clientName} onChange={(e) => setNewCase({...newCase, clientName: e.target.value})} required />
              <textarea placeholder="Beskrivelse av saken..." value={newCase.description} onChange={(e) => setNewCase({...newCase, description: e.target.value})} rows="4" required />
              <div className="form-buttons">
                <button type="submit" disabled={loading}>Opprett</button>
                <button type="button" onClick={() => setShowNewCase(false)}>Avbryt</button>
              </div>
            </form>
          )}
          <div className="cases-list">
            {cases.length === 0 ? (
              <p className="empty-state">Ingen saker ennå. Opprett din første sak!</p>
            ) : (
              cases.map(c => (
                <div key={c.id} className={`case-item ${selectedCase?.id === c.id ? 'active' : ''}`} onClick={() => setSelectedCase(c)}>
                  <div className="case-number">{c.caseNumber}</div>
                  <div className="case-client">{c.clientName}</div>
                  <div className="case-type">{c.caseType}</div>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="content">
          {selectedCase ? (
            <>
              <div className="case-header">
                <h2>{selectedCase.caseNumber} - {selectedCase.clientName}</h2>
                <button onClick={() => analyzeCase(selectedCase.id)} disabled={loading} className="analyze-btn">
                  {loading ? 'Analyserer...' : '🤖 Analyser med AI'}
                </button>
              </div>
              <div className="case-details">
                <div className="detail-row"><strong>Type:</strong> {selectedCase.caseType}</div>
                <div className="detail-row"><strong>Beskrivelse:</strong><p>{selectedCase.description}</p></div>
              </div>
              {analysis && (
                <div className="analysis-result">
                  <h3>📋 Juridisk analyse (IRAC)</h3>
                  <div className="analysis-section"><h4>Issue (Problemstilling)</h4><p>{analysis.issue || 'Ikke tilgjengelig ennå'}</p></div>
                  <div className="analysis-section"><h4>Rule (Rettskilder)</h4><p>{analysis.rule || 'Ikke tilgjengelig ennå'}</p></div>
                  <div className="analysis-section"><h4>Application (Subsumpsjon)</h4><p>{analysis.application || 'Ikke tilgjengelig ennå'}</p></div>
                  <div className="analysis-section"><h4>Conclusion (Konklusjon)</h4><p>{analysis.conclusion || 'Ikke tilgjengelig ennå'}</p></div>
                </div>
              )}
            </>
          ) : (
            <div className="empty-content"><p>Velg en sak fra listen eller opprett en ny sak</p></div>
          )}
        </div>
        </>
      ) : (
        // Admin view - Kunnskapsbase
        <div className="admin-container">
          <div className="admin-header">
            <h2>📚 Kunnskapsbase - Dommer</h2>
            <p>Last opp dommer (PDF eller TXT) som skal brukes i AI-analyser</p>
          </div>

          <div className="upload-section">
            <div className="upload-box">
              <input
                type="file"
                id="file-upload"
                multiple
                accept=".pdf,.txt"
                onChange={handleFileUpload}
                disabled={loading}
                style={{ display: 'none' }}
              />
              <label htmlFor="file-upload" className="upload-label">
                <div className="upload-icon">📤</div>
                <p>Klikk for å velge filer</p>
                <p className="upload-hint">PDF eller TXT - flere filer kan velges samtidig</p>
              </label>
            </div>

            {uploadProgress && (
              <div className={`upload-progress ${uploadProgress.startsWith('✅') ? 'success' : uploadProgress.startsWith('❌') ? 'error' : ''}`}>
                {uploadProgress}
              </div>
            )}
          </div>

          <div className="uploaded-files">
            <h3>Opplastede dommer ({uploadedFiles.length})</h3>
            {uploadedFiles.length === 0 ? (
              <p className="empty-state">Ingen dommer lastet opp ennå</p>
            ) : (
              <div className="files-list">
                {uploadedFiles.map((file, idx) => (
                  <div key={idx} className="file-item">
                    <div className="file-icon">📄</div>
                    <div className="file-info">
                      <div className="file-name">{file.name}</div>
                      <div className="file-meta">{file.type} • {file.size}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="admin-info">
            <h3>ℹ️ Slik fungerer det</h3>
            <ol>
              <li>Last opp dommer (PDF eller TXT)</li>
              <li>Systemet parser teksten automatisk</li>
              <li>Dommene legges til i Vectorize-databasen</li>
              <li>AI-analyser bruker dommene som rettskilder</li>
            </ol>
          </div>
        </div>
      )}

      </div>
    </div>
  );
}

export default App;
